import React from "react";

import { agentPermissionSet } from "helpers";
import { useAgentSearchQuery } from "queries";

import { agentResultItem } from "../resultItems";

import AgentIcon from "static/images/agent.png";

const agentSection = () => {
	return {
		name: "agents",
		title: "Agent",
		useSearchQuery: useAgentSearchQuery,
		renderItem: agentResultItem,
		getIcon: () => <img src={AgentIcon} alt="" />,
		getLink: ({ id }) => `/system-setup/agent-setup/edit-agent/${id}`,
		requiredPermissions: agentPermissionSet,
	};
};

export default agentSection;
